import _ from "lodash";
export default {
  getters: {
    BuTest: (state) => {
      return state.bu_test;
    },
    CloseOldinv: (state) => {
      return state.close_oldinv;
    },
    IsInvMI: (state) => {
      return state.is_inv_mi;
    },
    CanSave: (state) => {
      return state.canSave;
    },
    UserChannelType: (state) => {
      return state.user_channel_type;
    },
    IsMfTesters: (state) => {
      return state.isMfTesters;
    },
    McListObj: (state) => {
      return state.mcListObj;
    },
    MfEditing: (state) => {
      return state.mf_editing;
    },
    MfViewing: (state) => {
      return state.mf_saved;
    },
    //目前MF中有匯入的家庭成員
    MemberList: (state) => {
      return state.memberList;
    },
    QueryDetailTarget: (state) => {
      return state.queryDetailTarget;
    },
    MfPerformaceQueryList: (state) => {
      return state.performaceQueryList;
    },
    MfLoadingMask: (state) => {
      return state.mfLoadingMask;
    },
    MfEditingCompose: (state) => {
      return state.mf_editing_compose;
    },
    MfPdfBaseURL: (state) => {
      return state.mfPdfBaseURL;
    },
    IsDirectMarketingUser: (state) => {
      return state.isDirectMarketingUser;
    },
    IsBankUser: (state) => {
      return state.isBankUser;
    },
    PerfomaceProposal: (state) => {
      return state.proposalListData;
    },
    UnCheckedMc_idx: (state) => {
      return state.unCheckedItem;
    },
    kycRiskObjText: (state) => {
      return state.kycRiskObj;
    },
    proRiskObj: (state) => {
      return state.proposalRiskObj;
    },
    allRiskObj: (state) => {
      return state.allRiskObj;
    },
    CloseAll: (state) => {
      return state.close_all;
    },
    QualificationObj: (state) => {
      return state.qualificationObj;
    },
    EldqualificationObj: (state) => {
      return state.eldqualificationObj;
    },
  },
  state: {
    bu_test: false,
    close_oldinv: "1",
    is_inv_mi: true,
    canSave: true, //是否可以保存建議書
    isMfTesters: false,
    user_channel_type: "", //登入者通路
    isBankUser: false, //是否為保代人員
    isDirectMarketingUser: false, //是否為直效人員
    mcListObj: null,
    memberList: [],
    mf_editing: {
      prod_idx: "", //建議書IDX
      insurer: null, //要保人
      insured: null, //被保人
      sameInsurer: false, //同要被保人
      inputType: "noId", //family、noId,
      mc_prod_list: [],
      sc_prod_id_list: [], //不重複、有使用到的附約ID清單
    },
    mf_saved: {
      saveData: null,
    },
    customerDataTempJSON: "",
    privacyCustomerDataTempJSON: "",
    privacyCustomerChanged: false,
    queryDetailTarget: {
      is_crm: "",
      insured_id: "",
      prod_idx: "",
      familyid: "",
    },
    performaceQueryList: [],
    mfLoadingMask: false, //透明玻璃遮罩
    mf_editing_compose: {
      //編輯中的收藏組合
      setgroup_idx: "",
      group_mc_list: [],
    },
    mfPdfBaseURL: "",
    mf_event_log: {
      AGID: 0, //AGID
      IDX: 0, //建議書流水編
      reportIDX: 0, //報表流水編
      time: 0, //操作時間
      back: 0, //返回舊建議書
      create_tab: 0, //新增/輸入頁籤
      search_tab: 0, //查詢/列印頁籤
      checkup_tab: 0, //E檢核頁籤
      performance_tab: 0, //業績換算查詢
      collection_tab: 0, //我的收藏組合
      CRMfamily: 0, //搜尋CRM家戶
      calculation: 0, //空白建議書試算
      primary: 0, //選擇主約或商品組合
      primary_search: 0, //「選擇商品」裡面的主約商品名稱搜尋欄
      primary_hospital: 0, //「選擇商品」裡面的主約商品分類鈕：住院
      primary_surgery: 0, //「選擇商品」裡面的主約商品分類鈕：手術
      primary_payasyougo: 0, //「選擇商品」裡面的主約商品分類鈕：實支實付
      primary_catastrophic: 0, //「選擇商品」裡面的主約商品分類鈕：重大疾病
      primary_accident: 0, //「選擇商品」裡面的主約商品分類鈕：意外
      primary_longtermcare: 0, //「選擇商品」裡面的主約商品分類鈕：長照
      primary_life: 0, //「選擇商品」裡面的主約商品分類鈕：壽險
      primary_is: 0, //「選擇商品」裡面的主約商品分類鈕：利率變動傳統型理財商品
      primary_ilp: 0, //「選擇商品」裡面的主約商品分類鈕：投資型理財商品
      primary_collection: 0, //「選擇商品」裡面的商品組合方案鈕：我的收藏組合
      riderinsured: 0, //「選擇商品」裡面的新增其他被保人
      addincollection: 0, //將本次商品加入我的收藏
      save: 0, //儲存並進入下一步
      detail_edit: 0, //從「保費明細頁」點擊：修改建議書
      detail_print: 0, //從「保費明細頁」點擊：列印建議書
      detail_mi: 0, //從「保費明細頁」點擊：匯入行動投保
      detail_policyreview: 0, //從「保費明細頁」點擊：匯入保單健檢
      list_delete: 0, //從「建議書清單」點擊：刪除建議書
      list_edit: 0, //從「建議書清單」點擊：修改建議書
      list_print: 0, //從「建議書清單」點擊：列印建議書
      list_mi: 0, //從「建議書清單」點擊：匯入行動投保
      list_policyreview: 0, //從「建議書清單」點擊：匯入保單健檢
      print_pdf: 0, //開啟PDF
      print_mail: 0, //發送EMAIL
      collection_new: 0, //我的收藏組合裡面的「新增收藏」
    },
    proposalListData: [], // 更新業績換算商品資料
    unCheckedItem: [], // 重新勾選業績換算商品資料
    allRiskObj: [], // 所有客人風險屬性
    kycRiskObj: {}, // 產品風險屬性
    proposalRiskObj: {}, // 投資型商品建議書 riskObj
    close_all: false, //是否關閉回舊建議書按鈕
    qualificationObj: {}, //招攬資格
    eldqualificationObj: {}, //高齡招攬資格
  },
  mutations: {
    set_mfPdfBaseURL(state, payload) {
      state.mfPdfBaseURL = payload;
    },
    setMCListObj: (state, payload) => {
      state.mcListObj = payload;
    },
    update_MfEditing: (state, payload) => {
      state.mf_editing = {
        ...state.mf_editing,
        ...payload,
      };
    },
    reset_Customer: (state) => {
      state.memberList = [];
      state.mf_editing.insurer = null;
      state.mf_editing.insured = null;
      state.mf_editing.sameInsurer = false;
      state.mf_editing.isNew = true;
      state.mf_editing.inputType = "noId";
      state.queryDetailTarget = {
        is_crm: "",
        insured_id: "",
        prod_idx: "",
        familyid: "",
      };
      state.privacyCustomerDataTempJSON = "";
      state.privacyCustomerChanged = false;
    },
    reset_MfEditing: (state) => {
      if (state.mf_editing.inputType == "noId") {
        state.mf_editing = {
          prod_idx: "", //建議書IDX
          insurer: null, //要保人
          insured: null, //被保人
          sameInsurer: false, //同要被保人
          inputType: "noId", //family、noId,
          mc_prod_list: [],
          sc_prod_id_list: [],
        };
      } else {
        //家戶模式僅清空品
        state.mf_editing = {
          prod_idx: "", //建議書IDX
          insurer: state.mf_editing.insurer, //要保人
          insured: state.mf_editing.insured, //被保人
          sameInsurer: state.mf_editing.sameInsurer, //同要被保人
          inputType: state.mf_editing.inputType, //family、noId,
          mc_prod_list: [],
          sc_prod_id_list: [],
        };
      }
      state.privacyCustomerDataTempJSON = "";
      state.privacyCustomerChanged = false;
    },
    update_MfViewing: (state, payload) => {
      state.mf_editing.isNew = false;
      state.mf_saved = _.cloneDeep({
        ...state.mf_editing,
        ...payload,
      });
    },
    set_customerDataTempJSON(state, payload) {
      state.customerDataTempJSON = JSON.stringify({
        insurer: state.mf_editing.insurer,
        insured: state.mf_editing.insured,
        inputType: state.mf_editing.inputType,
        sameInsurer: state.mf_editing.sameInsurer,
      });
    },
    set_privacyCustomerDataTempJSON(state, payload) {
      state.privacyCustomerDataTempJSON = JSON.stringify(payload || {});
    },
    set_privacyCustomerChanged(state, payload) {
      state.privacyCustomerChanged = !!payload;
    },
    set_MemberList(state, payload) {
      state.memberList = payload;
    },
    update_queryDetailTarget(state, payload) {
      state.queryDetailTarget = payload;
    },
    set_performaceQueryList(state, payload) {
      state.performaceQueryList = payload;
    },
    update_proposalList(state, payload) {
      state.proposalListData = payload;
    },
    update_unChecked_mc_idx(state, { data }) {
      state.unCheckedItem = data;
    },
    update_mfLoadingMask(state, payload = false) {
      state.mfLoadingMask = payload;
    },
    //更新編輯中的收藏組合
    update_MfEditingCompose: (state, payload) => {
      state.mf_editing_compose = {
        ...state.mf_editing_compose,
        ...payload,
      };
    },
    reset_MfEditingCompose: (state, payload) => {
      state.mf_editing_compose = {
        setgroup_idx: "",
        group_mc_list: [],
      };
    },
    //event Log計數
    update_eventLog: (state, key) => {
      state.mf_event_log[key]++;
    },
    reset_eventLog: (state) => {
      for (let key in state.mf_event_log) {
        state.mf_event_log[key] = 0;
      }
    },
    update_canSave(state, payload = true) {
      state.canSave = payload;
    },
    set_user_channel_type: (state, userInfo) => {
      if (userInfo.divFullName.indexOf("直效") > -1 || userInfo.divFullName.indexOf("電話行銷") > -1 || userInfo.divFullName.indexOf("電銷") > -1 || userInfo.divShortName.indexOf("直效") > -1 || userInfo.divShortName.indexOf("電銷") > -1 || userInfo.divShortName.indexOf("電客一９組") > -1 || userInfo.divShortName.indexOf("客服一９組") > -1) {
        //是否為直效人員
        state.isDirectMarketingUser = true;
      }
      let user_channel_type = "1"; //預設為國壽通路
      if (
        userInfo.compId === "01" ||
        (userInfo.compId == "A0" &&
          userInfo.divFullName.indexOf("保險代理") > -1)
      ) {
        //判斷是否為世華理專(公司代號=01)和保代BU
        user_channel_type = "2";
        state.isBankUser = true;
      }
      state.user_channel_type = user_channel_type;
    },
    set_bu_test(state, payload) {
      state.bu_test = payload == "1";
    },
    set_close_oldinv(state, payload) {
      state.close_oldinv = payload;
    },
    set_is_inv_mi(state, payload) {
      if (payload == "1") {
        state.is_inv_mi = true;
      } else {
        state.is_inv_mi = false;
      }
    },
    set_isMfTesters(state, payload) {
      let front_access_array = payload.front_access
        ? payload.front_access.split(",")
        : [];
      //通路和數支科固定為測試人員，其餘單位參數後台設定
      if (front_access_array.includes(payload.divNo)) {
        state.isMfTesters = true;
      }
    },
    set_allRiskObj(state, data) {
      state.allRiskObj = data;
    },
    set_kycRiskObj(state, data) {
      state.kycRiskObj = data;
    },
    set_proRiskObj(state, data) {
      state.proposalRiskObj = data;
    },
    set_close_all(state, payload) {
      if (payload == "1") {
        state.close_all = true;
      } else {
        state.close_all = false;
      }
    },
    set_qualificationObj(state, payload) {
      state.qualificationObj = payload;
    },
    set_eldqualificationObj(state, payload) {
      state.eldqualificationObj = payload;
    },
  },
};
